import { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../contexts/UserContext';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import styles from './PostDisplay.module.css';
import server from '../../apis/server';
import Container from '../Container';
import PostCard from '../PostCard';
import PostColumn from '../PostColumn';
import UploadButton from '../UploadButton';
import Spinner from '../Spinner';

const PostDisplay = ({ images, isFetching, username }) => {
  const [displayImages, setDisplayImages] = useState([]);
  const [columnAmount, setColumnAmount] = useState(3);

  const { isLoggedIn } = useContext(UserContext);

  useEffect(() => {
    setDisplayImages(images);
  }, [images]);

  useEffect(() => {
    const calcColumnAmount = () => {
      const width = window.innerWidth;

      if (width < 600) setColumnAmount(2);
      else if (width > 600 && width < 900) setColumnAmount(3);
      else if (width > 900 && width < 1400) setColumnAmount(4);
      else if (width > 1400) setColumnAmount(5);
    };

    calcColumnAmount();

    window.addEventListener('resize', calcColumnAmount);

    return () => {
      window.removeEventListener('resize', calcColumnAmount);
    };
  }, []);

  const divideImages = () => {
    let arr = [];

    for (let i = 0; i < columnAmount; i++) {
      arr.push([]);
    }

    let iteration = 0;

    for (let i = 0; i < displayImages.length; i++) {
      arr[iteration].push(displayImages[i]);

      iteration++;

      if (iteration >= columnAmount) {
        iteration = iteration - columnAmount;
      }
    }

    let columns = [];

    for (let i = 0; i < arr.length; i++) {
      columns.push(
        <PostColumn key={i} columns={columnAmount}>
          {arr[i].map((card) => {
            return <PostCard username={username} data={card} key={card.id} />;
          })}
        </PostColumn>
      );
    }

    return columns;
  };

  const uploadFile = async (e) => {
    const file = e.target.files[0];

    const formData = new FormData();
    formData.append('upload', file);

    try {
      const res = await server.post('/images', formData);

      const newImages = [...displayImages];
      newImages.splice(0, 0, res.data);

      setDisplayImages(newImages);
    } catch (err) {}
  };

  return (
    <div className={styles.postDisplay}>
      <div className={styles.header}>
        <span className={styles.headerText}>Posts</span>
        {isLoggedIn && isLoggedIn.username === username && (
          <UploadButton onUpload={uploadFile} id="image-upload">
            <AddRoundedIcon className={styles.addIcon} style={{ fontSize: '2rem' }} />
          </UploadButton>
        )}
      </div>
      {isFetching && <Spinner containerClass={styles.spinner} />}
      <Container x="5rem">
        <div className={styles.posts}>{divideImages()}</div>
      </Container>
    </div>
  );
};

export default PostDisplay;
